export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const GET_DATA_FOR_REMOTE_MOBILE_AUTH = 'GET_DATA_FOR_REMOTE_MOBILE_AUTH'
